import type { ServiceType } from '../types/ServiceType';
import { OrderDeliveryServices } from './OrderDeliveryServices';

export const OrderServicesWithAllPaymentMethods: Array<ServiceType> = [
    OrderDeliveryServices.CDEK,
    OrderDeliveryServices.MERCHANT_SHIP,
    OrderDeliveryServices.META_SHIP_RUSSIAN_POST,
    OrderDeliveryServices.META_SHIP_PECOM,
    OrderDeliveryServices.META_SHIP_DALLI,
];
